/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import "./viewPackage.css";

const ViewPackage = ({ viewData }) => {
  const [activeTab, setActiveTab] = useState("productDetails");

  const tabs = [
    { id: "productDetails", label: "Product Details" },
    { id: "billing", label: "Billing" },
    { id: "keyword", label: "Keyword" },
    { id: "chargingConfig", label: "Charging Configuration" },
    { id: "fallback", label: "Fallback" },
    { id: "sms", label: "SMS" },
    { id: "partnerNotification", label: "Partner Notification" },
    { id: "customerNotification", label: "Customer Notification" },
  ];

  const renderChargingConfig = () => (
    <div className="tab-pane fade show active">
      <div className="row mb-3">
        <div className="form-group col-sm-6 mb-0">
          <div className="row  mobile-line-row">
            <div className="col-sm-4 label"><span>Renewal Retry</span> <span>:</span></div>
            <div className="col-sm-8 text-wrap cont_div">{viewData?.renRetry || "N/A"}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 mb-0">
          <div className="row  mobile-line-row">
            <div className="col-sm-4 label"><span>Retry Interval</span> <span>:</span></div>
            <div className="col-sm-8 fw-bold text-wrap cont_div">
              {viewData?.renRetryIntervalHour}:{viewData?.renRetryIntervalMin}
            </div>
          </div>
        </div>
        <div className="form-group col-sm-6 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-4 label"><span>Renewal Time</span> <span>:</span></div>
            <div className="col-sm-8 fw-bold text-wrap cont_div">
              {viewData?.renStartHour}:{viewData?.renStartMin} to {viewData?.renStopHour}:{viewData?.renStopMin}
            </div>
          </div>
        </div>
        <div className="form-group col-sm-6 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-4 label"><span>Notification Time</span> <span>:</span></div>
            <div className="col-sm-8 fw-bold text-wrap cont_div">
              {viewData?.renNotifyStartHour}:{viewData?.renNotifyStartMin} to {viewData?.renNotifyEndHour}:{viewData?.renNotifyEndMin}
            </div>
          </div>
        </div>
      </div>
      {/* <div className="row mb-3">
        <div className="form-group col-sm-6">
          <div className="row mobile-line-row">
            <div className="col-sm-4 label"><span>Renewal Time</span> <span>:</span></div>
            <div className="col-sm-8 fw-bold text-wrap cont_div">
              {viewData?.renStartHour}:{viewData?.renStartMin} to {viewData?.renStopHour}:{viewData?.renStopMin}
            </div>
          </div>
        </div>
        <div className="form-group col-sm-6">
          <div className="row mobile-line-row">
            <div className="col-sm-4 label"><span>Notification Time</span> <span>:</span></div>
            <div className="col-sm-8 fw-bold text-wrap cont_div">
              {viewData?.renNotifyStartHour}:{viewData?.renNotifyStartMin} to {viewData?.renNotifyEndHour}:{viewData?.renNotifyEndMin}
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );

  const renderCustomerNotification = () => (
    <div className="tab-pane fade show active">
      <div className="row mb-3">
        <div className="form-group col-sm-6 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-4 label"><span>Pre Renewal</span> <span>:</span></div>
            <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.preRenewal}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-4 label"><span>Renewal Notify </span><span>:</span></div>
            <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.renNotify}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-4 label"><span>Notify Frequency</span> <span>:</span></div>
            <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.renNotifyFreq}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-4 label"><span>Low Balance Notify </span><span>:</span></div>
            <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.lowBalNotify}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-4 label"><span>Cancel Notify</span> <span>:</span></div>
            <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.cancelNotify}</div>
          </div>
        </div>
        <div className="form-group col-sm-6 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-4 label"><span>Subscription Notify</span> <span>:</span></div>
            <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.subNotify}</div>
          </div>
        </div>
      </div>
      {/* <div className="row mb-3">
        <div className="form-group col-sm-6">
          <div className="row mobile-line-row">
            <div className="col-sm-4 label"><span>Notify Frequency</span> <span>:</span></div>
            <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.renNotifyFreq}</div>
          </div>
        </div>
        <div className="form-group col-sm-6">
          <div className="row mobile-line-row">
            <div className="col-sm-4 label"><span>Low Balance Notify </span><span>:</span></div>
            <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.lowBalNotify}</div>
          </div>
        </div>
      </div> */}
      {/* <div className="row mb-3">
        <div className="form-group col-sm-6">
          <div className="row mobile-line-row">
            <div className="col-sm-4 label"><span>Cancel Notify</span> <span>:</span></div>
            <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.cancelNotify}</div>
          </div>
        </div>
        <div className="form-group col-sm-6">
          <div className="row mobile-line-row">
            <div className="col-sm-4 label"><span>Subscription Notify</span> <span>:</span></div>
            <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.subNotify}</div>
          </div>
        </div>
      </div> */}
    </div>
  );

  return (
    <div>
      {/* Tabs Navigation */}
      <div className="nav-tabs-wrapper">
        <ul className="nav nav-tabs" role="tablist">
          {tabs.map(tab => (
            <li key={tab.id} className="nav-item">
              <a
                className={`nav-link ${activeTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* Tabs Content */}
      <div className="tab-content mt-3">
        {/* Product Details Tab */}
        {activeTab === "productDetails" && (
          <div className="tab-pane fade show active">
            <div className="row mb-3">
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Product Name</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.productName}</div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Product ID </span><span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.productId}</div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Package Type </span><span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.packType}</div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Description </span><span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.description}</div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Status </span><span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">
                    <span className="badge bg-success round_pill">
                      {viewData?.status ? "Active" : "Inactive"}
                    </span>
                  </div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Category </span><span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.category || "N/A"}</div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Alpha Numeric </span><span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.alphaNumeric || "N/A"}</div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Operator Service ID </span><span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.operatorServiceId || "N/A"}</div>
                </div>
              </div>
            </div>
            {/* <div className="row mb-3">
              <div className="form-group col-sm-6">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Package Type </span><span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.packType}</div>
                </div>
              </div>
              <div className="form-group col-sm-6">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Description </span><span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.description}</div>
                </div>
              </div>
            </div> */}
            {/* <div className="row mb-3">
              <div className="form-group col-sm-6">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Status </span><span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">
                    <span className="badge bg-success">
                      {viewData?.status ? "Active" : "Inactive"}
                    </span>
                  </div>
                </div>
              </div>
              <div className="form-group col-sm-6">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Category </span><span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.category || "N/A"}</div>
                </div>
              </div>
            </div> */}
          </div>
        )}

        {/* Billing Details Tab */}
        {activeTab === "billing" && (
          <div className="tab-pane fade show active">
            <div className="row mb-3">
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Price Point</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.pricePoint}</div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Validity (Days)</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.validity}</div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Renewal Type</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.renewalType}</div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Grace Duration</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.graceDuration} days</div>
                </div>
              </div>
            </div>
            {/* <div className="row mb-3">
              <div className="form-group col-sm-6">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Renewal Type</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.renewalType}</div>
                </div>
              </div>
              <div className="form-group col-sm-6">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Grace Duration</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.graceDuration} days</div>
                </div>
              </div>
            </div> */}
          </div>
        )}

        {/* Keyword Tab */}
        {activeTab === "keyword" && (
          <div className="tab-pane fade show active">
            <div className="row mb-3">
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Subscribe Keyword</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">
                    {viewData?.subKeyword || "N/A"}
                  </div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Arabic Subscribe Keyword</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">
                    {viewData?.subArabicKeyword || "N/A"}
                  </div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Unsubscribe Keyword</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">
                    {viewData?.unsubKeyword || "N/A"}
                  </div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Arabic Unsubscribe Keyword</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">
                    {viewData?.unsubArabicKeyword || "N/A"}
                  </div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Short Code</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.shortCode}</div>
                </div>
              </div>
            </div>
            {/* <div className="row mb-3">
              <div className="form-group col-sm-6">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Unsubscribe Keyword</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">
                    {viewData?.unsubKeyword || "N/A"}
                  </div>
                </div>
              </div>
              <div className="form-group col-sm-6">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Arabic Unsubscribe Keyword</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">
                    {viewData?.unsubArabicKeyword || "N/A"}
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="row mb-3">
              <div className="form-group col-sm-6">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Short Code</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.shortCode}</div>
                </div>
              </div>
            </div> */}
          </div>
        )}

        {/* Charging Configuration Tab */}
        {activeTab === "chargingConfig" && renderChargingConfig()}

        {/* Fallback Details Tab */}
        {activeTab === "fallback" && (
          <div className="tab-pane fade show active">
            <div className="row mb-3">
              <div className="col-sm-12">
                <h5>
                  Fallback Status:{" "}
                  {viewData?.isFallback ? "Enabled" : "Disabled"}
                </h5>
              </div>
            </div>
            {viewData?.appStoreProductFallbackModelList?.map(
              (fallback, index) => (
                <div key={fallback.id} className="row mb-3">
                  <div className="col-sm-12">
                    <h6>Fallback Option {index + 1}</h6>
                    <div className="row mb-2">
                      <div className="form-group col-sm-6 mb-0">
                        <div className="row mobile-line-row">
                          <div className="col-sm-4 label"><span>Price Point</span> <span>:</span></div>
                          <div className="col-sm-8 fw-bold text-wrap cont_div">{fallback.pricePoint}</div>
                        </div>
                      </div>
                      <div className="form-group col-sm-6 mb-0">
                        <div className="row mobile-line-row">
                          <div className="col-sm-4 label"><span>Validity</span> <span>:</span></div>
                          <div className="col-sm-8 fw-bold text-wrap cont_div">
                            {fallback.validity} days
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        )}

        {/* SMS Details Tab */}
        {activeTab === "sms" && (
          <div className="tab-pane fade show active">
            <div className="row mb-3">
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Subscription Message</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">
                    {viewData?.subscriptionMessage || "N/A"}
                  </div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Arabic Subscription Message</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">
                    {viewData?.subscriptionMessageArabic || "N/A"}
                  </div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Charging Message</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">
                    {viewData?.chargingMessage || "N/A"}
                  </div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Arabic Charging Message</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">
                    {viewData?.chargingMessageArabic || "N/A"}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row mb-3">
              <div className="form-group col-sm-6">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Charging Message</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">
                    {viewData?.chargingMessage || "N/A"}
                  </div>
                </div>
              </div>
              <div className="form-group col-sm-6">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Arabic Charging Message</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">
                    {viewData?.chargingMessageArabic || "N/A"}
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        )}

        {/* Customer Notification Tab */}
        {activeTab === "customerNotification" && renderCustomerNotification()}

        {/* Partner Notification Tab */}
        {activeTab === "partnerNotification" && (
          <div className="tab-pane fade show active">
            <div className="row mb-3">
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Notify URL</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.notifyUrl || "N/A"}</div>
                </div>
              </div>
              <div className="form-group col-sm-6 mb-0">
                <div className="row mobile-line-row">
                  <div className="col-sm-4 label"><span>Landing Page URL</span> <span>:</span></div>
                  <div className="col-sm-8 fw-bold text-wrap cont_div">{viewData?.lpUrl || "N/A"}</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Add this CSS to your stylesheet */}
    </div>
  );
};

export default ViewPackage;
